import React from 'react'
import PropTypes from 'prop-types'

import './cardBrands.css'

const Cardbrand = ({ isLoading, brands }) => {
  return isLoading ? (
    <div>
      <br />
      <div className='lds-roller'>
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  ) : (
    <div className='payment-icons row pt-2 px-half'>
      {brands.map((brand, index) => {
        return (
          <div className='col-auto px-half' key={index}>
            <img src={brand.imageUrl} alt={brand.name} />
          </div>
        )
      })}
    </div>
  )
}

Cardbrand.propTypes = {
  isLoading: PropTypes.bool,
  brands: PropTypes.array
}

export default Cardbrand



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/Payment/CardBrands/CardBrands.js